// ---------------------------------------------------------------------------
// File: src/Components/payments/TrialDialog.jsx
// ---------------------------------------------------------------------------
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    Box,
    Typography,
    DialogContent,
    DialogActions,
    Button,
    Alert,
    RadioGroup,
    Radio,
    FormControl,
    FormControlLabel,
    FormLabel,
    CircularProgress
} from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';

import Constants from '../../assests/Constants/constants';
import PaymentService from '../../Services/payment.service';
import AuthService from '../../Services/auth.service';
// ────────────────────────────────────────────────────────────────────────────
// const MODAL_STYLE = {
//     position: 'absolute',
//     top: '50%', left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '90%', maxWidth: 560,
//     bgcolor: 'background.paper',
//     borderRadius: 3,
//     boxShadow: 24,
//     p: 4
// };
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 800,
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    px: 4,
    py: 3
};
// Amount of trial days to send – customise if you have server-side defaults
const TRIAL_DAYS = Constants.TrialDays;

// ────────────────────────────────────────────────────────────────────────────
const TrialDialog = ({
    open,
    isAccountant,       // numeric Constants.UserType.*
    onSuccess       // callback after server accepted
}) => {

    const { t, i18n } = useTranslation();
    const dir = i18n.dir();

    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);



    const handleStart = async () => {
        setBusy(true); setError('');

        try {
            const userId = await AuthService.getCurrentUserTypeId();
            if (isAccountant)
                await PaymentService.accountant.startTrial({
                    UserId: userId,
                    TrialDays: TRIAL_DAYS
                });
            else
                await PaymentService.client.startTrial({
                    UserId: userId,
                    TrialDays: TRIAL_DAYS
                });

            setDone(true);
            setTimeout(onSuccess, 1500);           // let the green banner show
        }
        catch (ex) {
            setError(ex.message || t('TrialStartFailed'));
        }
        finally {
            setBusy(false);
        }
    };



    // ─────────────────────────── render ──────────────────────────────
    return (
        <Modal open={open} onClose={() => { }} disableEscapeKeyDown>
            <Box sx={modalStyle} dir={dir}>

                <Typography variant="h6" gutterBottom display="flex" alignItems="center" gap={1}>
                    <InfoIcon fontSize="inherit" /> {t('FreeTrialTitle')}
                </Typography>

                <DialogContent dividers sx={{ mb: 2 }}>
                    {done ? (
                        <Alert severity="success" icon={<CheckIcon fontSize="inherit" />}>
                            {t('TrialStartedThankYou')}
                        </Alert>
                    ) : (
                        <>
                            <Typography sx={{ mb: 1.5 }}>
                                {isAccountant
                                    ? t('TrialExplainAccountant', { days: TRIAL_DAYS })
                                    : t('TrialExplainClient', { days: TRIAL_DAYS })}
                            </Typography>

                            {error &&
                                <Alert severity="error" sx={{ mt: 1 }} icon={<ErrorIcon fontSize="inherit" />}>
                                    {error}
                                </Alert>}
                        </>
                    )}
                </DialogContent>

                {!done && (
                    <DialogActions>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={busy}
                            onClick={handleStart}
                            startIcon={busy && <CircularProgress size={20} />}
                        >
                            {t('StartTrialNow')}
                        </Button>
                    </DialogActions>
                )}
            </Box>
        </Modal>

    );
};

// ─────────────────────────── prop-types ─────────────────────────────
TrialDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    isAccountant: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func.isRequired
};

export default TrialDialog;